import { PromotionsMutationTypes } from './types';

export const mutations = {
    [PromotionsMutationTypes.SetPromotions](state, { promotions }) {
        state.promotions = promotions || { data: [], total: 0 };
    },
    [PromotionsMutationTypes.SetEmptyPromotions](state) {
        state.promotions = { data: [], total: 0 };
    },
    [PromotionsMutationTypes.SetChangedPromotion](state, { promotion }) {
        const list = state.promotions && state.promotions.data;
        if (!Array.isArray(list) || !promotion) {
            return;
        }
        const foundIndex = list.findIndex((item) => item._id === promotion._id);
        if (foundIndex === -1) {
            return;
        }
        list.splice(foundIndex, 1, promotion);
    },
    [PromotionsMutationTypes.SetDeletedPromotion](state, { id }) {
        const list = state.promotions && state.promotions.data;
        if (!Array.isArray(list)) {
            return;
        }
        const foundIndex = list.findIndex((item) => item._id === id);
        if (foundIndex === -1) {
            return;
        }
        list.splice(foundIndex, 1);
        if (state.promotions.total > 0) {
            state.promotions.total -= 1;
        }
    },
};
